$(document).ready(function(){
  if($(".wrp-product-media-slider li").length > 1) {
    $('.wrp-product-media-slider').slick({
      // infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      adaptiveHeight: true
    });
  }
  
  $(document).on("click",".dropdown-cart .close-drawer svg",function() {
    $("body").removeClass("open-cart");
  });

  $(document).on("click",".header-bottom .top-cart a.cartToggle",function(event) {
    event.preventDefault();
    $("body").toggleClass("open-cart");
  });

  $(".open").on("click", function(){
    $(".popup-overlay, .popup-content").addClass("active");
  });

  // removes the "active" class to .popup and .popup-content when the "Close" button is clicked 
  $(".close").on("click", function(){
    $(".popup-overlay, .popup-content").removeClass("active");
  });
  
  // for cart page qty
  $(".template-cart .quantity__button").on("click", function () {
    var $button = $(this);
    var oldValue = $button.parent().find("input.qty").val();
    console.log(oldValue);

    if ($button.hasClass("btn-plus")) {
      var newVal = parseFloat(oldValue) + 1;
    } else {
      // Don't allow decrementing below zero
      if (oldValue > 0) {
        var newVal = parseFloat(oldValue) - 1;
      } else {
        newVal = 0;
      }
    }
    $button.parent().find("input.qty").val(newVal);
  });

  $(".first_btn").click(function() {
    $(".refined-widgets a").trigger("click");
  });

  $(".sec_btn").click(function() {
    $(".close").trigger("click");
  });

  $(".icon_dropdown_desk").on("click", function(){
    $(this).parent("li.dropdown").toggleClass('open_desk_menu');
    $(this).parent(".open_coll_dropdown").find(".site_desk_toggle_nav").toggleClass("hide");
  });

  $(document).on("click", ".quantity__button.btn-minus", function () {
    const $wrapper = $(this).closest(".wrp-qty-btn-input");
    const $input = $wrapper.find(".quantity_input");

    if (!$input.length) return;

    let qty = parseInt($input.val(), 10);

    if (!isNaN(qty)) {
      if (qty === 1) {
        // Set to 0 manually
        $input.val(0);
        qty = 0;
      }

      if (qty <= 0) {
        const $removeBtn = $wrapper.find(".btn-remove");
        if ($removeBtn.length) {
          // Slight delay just in case DOM needs to update first
          setTimeout(() => {
            $removeBtn.trigger("click");
          }, 10);
        }
      }
    }
  });

  $(".site-nav .threelevel-list li").each(function() {
    $(this).click(function(e){
      var bold_text = $(this).text().trim();
      localStorage.setItem('bold', bold_text);
      localStorage.getItem('bold');
      var texts = $(this).parents('.dropdown').find('.link_title').attr('data-link_title');
      localStorage.setItem('favourited', texts);
      localStorage.getItem('favourited');
    });
  });

  $(document).ready(function() {
    var storage_val = localStorage.getItem('favourited');
    var storage_bold = localStorage.getItem('bold');

    if(storage_bold){
      $(".site-nav .threelevel-list li").each(function(index) {
        var bold_class = $(this).text().trim();
        if(storage_bold == bold_class ){
          $(this).addClass("active");
        }
      });
    }
  });

  $(".site-nav .link_title").click(function(){
    var link__head = $(this).text().trim();
    localStorage.setItem('favourited', link__head);
    localStorage.getItem('favourited');
  });

  $(document).ready(function() {
    var stor_val = localStorage.getItem('favourited');
    if(stor_val){
      $(".sidebar_menu_desk li.dropdown").each(function(index) {
        var main_class = $(this).find('span.link_title').text().trim();
        if(stor_val == main_class){
          $(this).addClass('open_coll_dropdown');
        }
      });
    }
  });

  // === SWATCH → SKU (SellerDash) ===
jQuery('.swatch :radio').change(function() {
  // slick goto slide (valgfrit – kan kommenteres ud hvis du vil holde det simpelt)
  let mediaId = $(this).attr("data-media-id");
  let slickIndex = $(`.wrp-product-media-slider .slick-slide[data-media-id="${mediaId}"]`).eq(0).attr("data-slick-index");
  if (typeof slickIndex !== 'undefined') {
    $(".wrp-product-media-slider.slick-initialized").slick('slickGoTo', slickIndex);
  }

  var mix_val = '';
  $(this).closest('form').find('.swatch').each(function(){
    $(this).find('.swatch-element').each(function(){
      if($(this).find('input').is(":checked")){
        mix_val = mix_val + ' / ' + $(this).find('input').val();
      }
    });
  });

  var final_val = mix_val.substr(1);

  $("#product-selectors option").each(function(){
    if($(this).text().trim() == final_val){
      var sku_get = $(this).attr("data-sku");
      $(".sku_get").text(sku_get);
    }
  });
});


}); // <-- slut på $(document).ready


// Sticky header
$(window).scroll(function(){
  var sticky = $('.sticky'),
      scroll = $(window).scrollTop();

  if (scroll >= 100) sticky.addClass('fixed');
  else sticky.removeClass('fixed');
});


// custom store locator. 
document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (event) {
    let quicksizeElem = event.target.closest(".custom-lsn-switchers");
    
    if (quicksizeElem) {

      let productCard = quicksizeElem.closest(".custom-lsn-wrapper");

      if (!productCard) return;

      document.querySelectorAll(".custom-lsn-switchers.active").forEach((elem) => {
        if (elem !== quicksizeElem) {
          elem.classList.remove("active");
        }
      });

      quicksizeElem.classList.toggle("active");
    }
  });
});



document.addEventListener('DOMContentLoaded', () => {
  const openerBtns = document.querySelectorAll('.popup-opener-button');
  const popupSignin = document.querySelector('.popup-signin');
  const popupOverlay = document.querySelector('.ps-overlay');
  const popupCloseButton = document.querySelector('.close-btn');

  // Guard: ensure all key elements exist
  if (!popupSignin || !popupOverlay) return;

  const openPopup = () => {
    popupSignin.classList.add('active');
    popupOverlay.classList.add('active');
  };

  const closePopup = () => {
    popupSignin.classList.remove('active');
    popupOverlay.classList.remove('active');
  };

  // Open buttons
  openerBtns.forEach(btn => btn.addEventListener('click', openPopup));

  // Close when clicking overlay or close button
  popupOverlay.addEventListener('click', closePopup);
  popupCloseButton?.addEventListener('click', closePopup);
});

